require('../js/imagesloaded.min'); //require('fancybox')($)
//require('mediaelement')


require('../js/scripts');

require('../js/bootstrap.min'); //require('slick-carousel')


require('../sass/style.scss');